$(function() {
  if (location.hash && location.hash.match(/^#like-modal-/)) {
    const el = document.querySelector(`[data-bs-target='${location.hash}']`)
    $(el).click();
  }
});
